/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { EmbedFieldDisplay } from "./display";
import { EmbedFieldEdit } from "./edit";

const EmbedField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <EmbedFieldDisplay />,
        editComponent: <EmbedFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
EmbedField.displayName = "EmbedField";
export { EmbedField };
